// Import clients images
import client1 from '../../Assets/images/clients/client-1.png';
import client2 from '../../Assets/images/clients/client-2.png';
import client3 from '../../Assets/images/clients/client-3.png';
import client4 from '../../Assets/images/clients/client-4.png';
import client5 from '../../Assets/images/clients/client-5.png';
import client6 from '../../Assets/images/clients/client-6.png';
import client7 from '../../Assets/images/clients/client-7.png';
import client8 from '../../Assets/images/clients/client-8.png';
import client9 from '../../Assets/images/clients/client-9.png';
import client10 from '../../Assets/images/clients/client-10.png';
import client11 from '../../Assets/images/clients/client-11.png';
import client12 from '../../Assets/images/clients/client-12.png';
import client13 from '../../Assets/images/clients/client-13.png';
import client14 from '../../Assets/images/clients/client-14.png';
import client15 from '../../Assets/images/clients/client-15.png';
import client16 from '../../Assets/images/clients/client-16.png';
import client17 from '../../Assets/images/clients/client-17.png';
import client18 from '../../Assets/images/clients/client-18.png';
import client19 from '../../Assets/images/clients/client-19.png';
import client20 from '../../Assets/images/clients/client-20.png';
import client21 from '../../Assets/images/clients/client-21.png';
import client22 from '../../Assets/images/clients/client-22.png';
import client23 from '../../Assets/images/clients/client-23.png';
import client24 from '../../Assets/images/clients/client-24.png';
import client25 from '../../Assets/images/clients/client-25.png';

const aboutData =
    {
        name:'About us',
        deatils: [
            {
                id:1,
                name: 'Mac Line Properties and Contracting is a subsidiary of Mac Line Group.'
            },
            {
                id:2,
                name: 'Mac Line Group is a local general building and properties management , Company in Abu Dhabi, established in 2009,built solely on trust and recommendation   operating locally in Abu Dhabi and Western Region, covering both commercial and residential projects .'
            },
            {
                id:3,
                name: 'From maintenance Mac Line Group has diversied its frame work of investments to Contracting services and Corporate Real Estate within its sectors of operations and established a range of companies serving a dierent bunch of sectors in Abu Dhabi and UAE community'
            },
            {
                id:4,
                name: 'Mac Line Properties and Contracting LLC is oering services that are all carried out by skilled, fully insured, Engineers and tradesmen and as a company have two morals customer satisfaction and professional quality work. We can provide equality team of tradesmen to carry out one-o repairs or complete building projects. We pride our selves on being competitive on price without it’s impeding on quality.'
            }
        ],
        vision:'Our Vision is to be one of the regional leading contracting companies that integrally and efficiently serves our clients by pursuing excellence through an on going efforts passionate, dedicated and disciplined employees to deliver quality and timely projects.',
        mision:'Our Mission is to foster a work environment that encourages integrity, creativity continuous improvement and respect and to establish a lasting and successful partnership with our customers through being their preeminent provider of personalized, innovative affordable and sustainable contracting service.',
        clients: [
            {
                id:1,
                image:client1,
            },
            {
                id:2,
                image:client2,
            },
            {
                id:3,
                image:client3,
            },
            {
                id:4,
                image:client4,
            },
            {
                id:5,
                image:client5,
            },
            {
                id:6,
                image:client6,
            },
            {
                id:7,
                image:client7,
            },
            {
                id:8,
                image:client8,
            },
            {
                id:9,
                image:client9,
            },
            {
                id:10,
                image:client10,
            },
            {
                id:11,
                image:client11,
            },
            {
                id:12,
                image:client12,
            },
            {
                id:13,
                image:client13,
            },
            {
                id:14,
                image:client14,
            },
            {
                id:15,
                image:client15,
            },
            {
                id:16,
                image:client16,
            },
            {
                id:17,
                image:client17,
            },
            {
                id:18,
                image:client18,
            },
            {
                id:19,
                image:client19,
            },
            {
                id:20,
                image:client20,
            },
            {
                id:21,
                image:client21,
            },
            {
                id:22,
                image:client22,
            },
            {
                id:23,
                image:client23,
            },
            {
                id:24,
                image:client24,
            },
            {
                id:25,
                image:client25,
            },
        ]
        // integrity: 'Always act fairly, ethically and honestly in dealing with our employees, customers and vendors in all situations. Treat people how you want to be treated!',
        // manPower: `
        // Our network of 380 directly and indirectly employed, skilled professionals ensures we provide a consistent level of excellent service.
        // Training and development are keys to our success and we ensure all our employees are provided with regular training in areas such as new technology,  health and safety and customer service.
        // We also ensure all our employees have the opportunity to develop their careers with the business, as well as attracting some of the brightest and best talent from elsewhere.`,
    }


export default aboutData;